import Auth from '../../helpers/Auth';
import Storage from '../../helpers/Storage'
import { RESTART_CARRITO } from '../../store/conts';

import {
    SET_CARTS,
    ADD_CART
} from '../types'

const initialState = {
    cart: {},
    error: null,
    loanding: false
}

const cartReducer = (state = initialState, { type, payload }) => {
    let carts;

    switch (type) {
        case SET_CARTS:

            if (Object.keys(payload).length > 0) {
                //Storage.setCart(payload);     
                Auth.setCarrito(payload)
            } else {
                //Storage.removeCart();
                Auth.setCarrito({})
            }

            //Storage.setCart(payload);
            return {
                ...state,
                cart: payload
            }
        case ADD_CART:
            carts = {
                ...state,
                cart: {
                    ...state.cart,
                    ...payload
                }
            }

            //Storage.setCart(carts.cart);
            Auth.setCarrito(carts.cart)
            return carts
        case RESTART_CARRITO:
            return { ...initialState };
        default:
            return state;
    }
}

export default cartReducer;